import * as React from 'react';
import clsx from 'clsx';

import {InputReact} from 'common/components/input';

interface MenuSearchBarProps {
  value: string;
  handleSearchInput: (value: string) => void;
  placeholder?: string;
  children?: React.ReactNode;
  className?: string;
}

/**
 * Search bar for a child menu, all children passed into this component
 * are rendered to the right side of the search input
 */
export const MenuSearchBar = React.forwardRef<HTMLInputElement, MenuSearchBarProps>((props, ref) => {
  const placeholder = props.placeholder || `Search...`;
  return (
    <div className={clsx(props.className, `search-wrapper`)}>
      <InputReact
        ref={ref as any}
        icon={`search`}
        autoFocus
        placeholder={placeholder}
        showClear
        elref={`searchInput`}
        value={props.value}
        onInput={(ev) => props.handleSearchInput(ev.target.value)}
        onClear={() => props.handleSearchInput(``)}
      />
      {props.children}
    </div>
  );
});
